/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
  GetApiV1PersonSharedStudentEnrollmentsQueryParams,
  GetApiV1PersonSharedStudentEnrollments401,
  GetApiV1PersonSharedStudentEnrollments500,
} from "../../types/personSharedController/GetApiV1PersonSharedStudentEnrollments.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedStudentEnrollments } from "../../clients/personSharedController/getApiV1PersonSharedStudentEnrollments.ts";

export const getApiV1PersonSharedStudentEnrollmentsQueryKey = (
  params?: GetApiV1PersonSharedStudentEnrollmentsQueryParams,
) =>
  [
    { url: "/api/v1/person/shared/student-enrollments" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1PersonSharedStudentEnrollmentsQueryKey = ReturnType<
  typeof getApiV1PersonSharedStudentEnrollmentsQueryKey
>;

export function getApiV1PersonSharedStudentEnrollmentsQueryOptions(
  params?: GetApiV1PersonSharedStudentEnrollmentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedStudentEnrollmentsQueryKey(params);
  return queryOptions<
    GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedStudentEnrollments401
      | GetApiV1PersonSharedStudentEnrollments500
    >,
    GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedStudentEnrollments(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Busca pelo nome ou e-mail do aluno e retorna as matrículas (CourseRegistration) no formato Key/Value: Key = Id da matrícula, Value = "Nome [Email] Código da Turma". Filtro vazio retorna lista vazia. **(Requer Authorization para autenticação)**
 * @summary Buscar matrículas do aluno por nome ou e-mail (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/student-enrollments}
 */
export function useGetApiV1PersonSharedStudentEnrollments<
  TData = GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
  TQueryData = GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonSharedStudentEnrollmentsQueryKey,
>(
  params?: GetApiV1PersonSharedStudentEnrollmentsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedStudentEnrollments401
          | GetApiV1PersonSharedStudentEnrollments500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedStudentEnrollmentsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1PersonSharedStudentEnrollmentsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedStudentEnrollments401
      | GetApiV1PersonSharedStudentEnrollments500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
